document.addEventListener("DOMContentLoaded", () => {
    // Mapping of cities to their corresponding pincodes
    const cityPincodeMapping = {
        "Bangalore": "560001",
        "Chennai": "600001",
        "Delhi": "110001",
        "Pune": "411001",
        "Mumbai": "400001"
    };

    // Select the City and PIN code input fields
    const cityField = document.querySelector('input[name="City"]');
    const pincodeField = document.querySelector('input[name="PIN code"]');

    // Check if the fields exist before adding the event listener
    if (cityField && pincodeField) {
        cityField.addEventListener("input", () => {
            const city = cityField.value.trim(); // Get the city name and remove extra spaces
            if (cityPincodeMapping[city]) {
                pincodeField.value = cityPincodeMapping[city]; // Populate the pincode
            } else {
                pincodeField.value = ""; // Clear the pincode if no matching city is found
            }
        });
    }
});
